import React from 'react'
import PropTypes from 'prop-types'

export class BaseCompanyModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      valid: false,
      name: '',
      sourceReference: '',
      isCompanyActive: false
    }
    this.save = this.save.bind(this)
    this.statusToggleRef = React.createRef()
    this.companyNameRef = React.createRef()
    this.importCompanyRef = React.createRef()
  }

  handleSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      valid: true
    }, this.save)
  }

  handleErrorSubmit = (e, formData, errorInputs) => {
    e.preventDefault()
    e.stopPropagation()
    console.error(errorInputs)
  }

  componentDidMount () {
    this.setState({
      valid: false
    }, () => {
      this.setup()
    })
  }

  handleToggleChange = (e) => {
    this.setState({ isCompanyActive: e.target.checked }, () => {
      this.statusToggleRef.current.label = e.target.checked ? 'Yes' : 'No'
    })
  }

  handleCancel = (e) => {
    this.companyNameRef.current.required = false
    this.props.companyModalRef.current.close()
  }

  setup = () => {
    this.companyNameRef.current.required = true
    this.props.companyModalRef.current.addEventListener('close', (e) => this.handleCancel(e))
    this.props.companyModalRef.current.addEventListener('submit', (e) => this.handleSubmit(e))
    this.props.companyModalRef.current.addEventListener('show', () => this.handleOpened())
    this.statusToggleRef.current.label = this.state.isCompanyActive ? 'Yes' : 'No'
    this.statusToggleRef.current.checked = this.state.isCompanyActive
    this.statusToggleRef.current.addEventListener('change', (e) => this.handleToggleChange(e))
    this.companyNameRef.current.addEventListener('change', (e) => this.handleInputChange(e))
    this.importCompanyRef.current.addEventListener('change', (e) => this.handleInputChange(e))
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleOpened = () => {
    this.setState({
      valid: false,
      name: this.props.name,
      sourceReference: this.props.sourceReference,
      isCompanyActive: this.props.isCompanyActive
    }, () => {
      this.statusToggleRef.current.label = this.state.isCompanyActive ? 'Yes' : 'No'
      this.statusToggleRef.current.checked = this.state.isCompanyActive === undefined ? false : this.state.isCompanyActive
    })
  }

  save () {
    this.props.companyModalRef.current.close()
    if (this.state.valid) {
      this.props.saveFunction(this.state.name, this.state.sourceReference, this.state.isCompanyActive)
    }
  }

  render () {
    return (
      <mosaic-form-dialog
        ref={this.props.companyModalRef}
        header-title = {this.props.header}
        size='lg'
      >
        <div className='mb-2'>
          <mosaic-text-input
            label='Name'
            name='name'
            id='company-name'
            value={this.state.name}
            ref={this.companyNameRef}
            required
            pattern='[ A-Za-z0-9.,@()_-]+'
          />
          <div className='small pt-1 s-block text-muted'>Name can only contain A-Z a-z 0-9 _ - () @. , characters</div>
        </div>
        <div className='mb-2'>
          <mosaic-text-input
            label='Import company'
            name='sourceReference'
            id='source-reference'
            ref={this.importCompanyRef}
            value={this.state.sourceReference}
            pattern='[ A-Za-z0-9.,@()_-]+'
          />
          <div className='small pt-1 s-block text-muted'>
             The value must be unique and match the value exported from the FMS application in the company field.
              And this field can only contain A-Z a-z 0-9 _ - () @. , characters
          </div>
        </div>
        <div className='form-group'>
          <p className='font-weight-bold mb-1'>Is your company active?</p>
          <mosaic-toggle
            color='success'
            ref={this.statusToggleRef}
            label={`${this.state.isCompanyActive ? 'Yes' : 'No'}`}
            id='isActive'
            name='isCompanyActive'
            value={this.state.isCompanyActive}
          />
        </div>
      </mosaic-form-dialog>

    )
  }
}

BaseCompanyModal.propTypes = {
  companyModalRef: PropTypes.func,
  cancelFunction: PropTypes.func,
  companyActionButtonName: PropTypes.string,
  header: PropTypes.string,
  isOpen: PropTypes.bool,
  index: PropTypes.number,
  isCompanyActive: PropTypes.bool,
  name: PropTypes.string,
  sourceReference: PropTypes.string,
  saveFunction: PropTypes.func,
  toggle: PropTypes.func
}
